import React from 'react';
import { deleteOfficeRevenue } from '../../redux/officeSlice';
// import Bin from '../../assets/bin.svg';
import {ReactComponent as Bin} from '../../assets/bin.svg';
import { useDispatch } from 'react-redux';

const RevenueItem = ({ _id, order, amount, worker, comment, createdAt }) => {
    const workerLabel = worker ? `${worker.fullname}_` : 'Без мастера_';
    const name = order ? `${workerLabel}${order.id}` : comment;
    const createdDate = new Date(createdAt).toLocaleString('ru').split(', ').join(' в ');
    const dispatch = useDispatch();

    const deleteHandler = () => {
        if (window.confirm('Удалить доход?')) {
            dispatch(deleteOfficeRevenue(_id));
        }
    }
    return (
        <div className="revenue__item">
            <div title={createdDate}>{createdDate}</div>
            <div>{name}</div>
            <div>{amount}</div>
            {!order && <div className="revenue__item-delete revenue__item-btn">
                <Bin width={24} height={24} className={`button`} onClick={deleteHandler} />
            </div>}
        </div>
    );
};

export const Revenues = ({ list, error }) => {
    const titles = ['Дата', 'Доход', 'Сумма'];

    const sortedList = [...list].sort((a, b) => b.details.handOver.at - a.details.handOver.at);

    return (
        <div className="office__revenues revenues">
            <div className="revenue__titles-container">
                <div className="revenues__titles">
                    {titles.map((title, index) => (
                        <div key={index}>{title}</div>
                    ))}
                </div>
            </div>
            <div className="revenues__list" style={{ height: list.length ? 'auto' : '100%' }}>
                {list.length ? (
                    sortedList.map((r) => (
                        <RevenueItem _id={r._id} createdAt={r.details.handOver.at} key={r._id} order={r.order} worker={r.worker} amount={r.amount} comment={r.comment} />
                    ))
                ) : (
                    <div className="no-items">{error || 'Нет доходов'}</div>
                )}
            </div>
        </div>
    );
};
